var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"servicos"}},[_c('Header'),_c('Banner'),_c('QuemSomos'),_c('Servicos'),_c('Conecta')],1)}
var staticRenderFns = []

export { render, staticRenderFns }